import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '../../common/components/image';
import Checkbox from "../../common/components/forms/checkbox";
import {formatDurationAsTime} from "../../common/components/forms/format";

export class AlbumItemThumbnail extends React.Component {
    constructor(props) {
        super(props);
        this.playVideo = this.playVideo.bind(this);
        this.touchEnd = this.touchEnd.bind(this);
        this.isMobile = this.isMobile.bind(this);
        this.state = {
            touchStart: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.scrollIntoView) {
            this.thumbnailContainer.scrollIntoView();
        }
    }

    componentDidMount() {
        if (typeof (this.videoEl) != "undefined") {
            this.videoEl.addEventListener("fullscreenchange", function (event) {
                //alert("fullscreenchange")
            })
            this.videoEl.addEventListener("webkitendfullscreen", function (event) {
                //TODO: figure out how to revert back to the poster image
                //alert("webkitendfullscreen")
                //this.videoEl.poster.show();
            })
        }
    }

    isMobile() {
        return (screen.width < 500 ||
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPod/i));
    }

    playVideo(event, videoElId) {
        if (this.isMobile() && !this.props.isSelectMode && !this.props.isArrangeMode) {
            let videoEl = document.getElementById(videoElId);
            //There is no isPlaying attribute.  This is the closest
            if ((videoEl.currentTime > 0 && !videoEl.paused && !videoEl.ended && videoEl.readyState > 2)) {
                videoEl.pause();
            } else {
                videoEl.play();
                if (videoEl.requestFullscreen) {
                    videoEl.requestFullscreen();
                } else if (videoEl.webkitRequestFullscreen) {
                    videoEl.webkitRequestFullscreen();
                } else if (videoEl.mozRequestFullScreen) {
                    videoEl.mozRequestFullScreen();
                } else if (videoEl.msRequestFullscreen) {
                    videoEl.msRequestFullscreen();
                }
            }
            event.stopPropagation();
        }
    }

    touchEnd(event, videoElId) {
        if (new Date().getTime() - this.state.touchStart < 300) {
            //alert("Tap detected");
            this.playVideo(event, videoElId);
        } else {
            //alert("Drag detected");
        }
    }

    render() {
        return this.props.image
            ? <div className={`album-item-thumbnail-container`}
                   data-album-display-order={this.props.albumItemDisplayOrder}
                   data-album-item-id={this.props.albumItemId}
                   ref={el => {
                       this.thumbnailContainer = el;
                   }}>

                <div className={`${this.props.type === 'video' ? 'video-icon' : ''}`}></div>

                {/*Need to add time duration*/}
                {this.props.duration &&
                <div className="video-duration">{formatDurationAsTime(this.props.duration)}</div>}

                {this.props.isEdited &&
                <div className="edited-badge"/>
                }

                {this.props.isOnDisc &&
                <div className="disc-badge"/>
                }

                {/*{getImageForDisplayMode(this.props.selectMode, this.props.selectItem, this.props.selected, this.props.albumItemId, this.props.albumItemDisplayOrder)}*/}
                {this.props.type !== "video" &&
                <Image
                    className={`album-item-thumbnail ${this.props.rotation === 0 ? 'view-image' : this.props.rotation === 90 ? 'view-image-90' : this.props.rotation === 180 ? 'view-image-180' : this.props.rotation === 270 ? 'view-image-270 ' : ''} ${this.props.selected ? ' album-item-selected' : ''}`}
                    data-album-item-id={this.props.albumItemId}
                    data-album-display-order={this.props.albumItemDisplayOrder}
                    id={"thumbnail_" + this.props.albumItemId}
                    source={this.props.image}
                />
                }
                {this.props.type === "video" &&
                <video poster={this.props.image}
                       src={this.props.srcMediaUrl}
                       className={"album-item-thumbnail view-image"}
                       id={"thumbnail_" + this.props.albumItemId}
                       onClick={(event) => this.playVideo(event, "thumbnail_" + this.props.albumItemId)}
                       controls={false}
                       onTouchStart={(event) => this.setState({touchStart: new Date().getTime()})}
                       onTouchEnd={(event) => this.touchEnd(event, "thumbnail_" + this.props.albumItemId)}
                       ref={elem => this.videoEl = elem}
                />}

            </div>
            : <div className="album-item-thumbnail-container asset-error">
            </div>;
    }
};


const getImageForDisplayMode = (selectMode, clickHandler, selected, albumItemId, albumItemDisplayOrder) => {
    if (selectMode) {
        return (
            <div className="album-thumbnail-check" data-album-item-id={albumItemId}
                 data-album-display-order={albumItemDisplayOrder}>
                <Checkbox checked={selected} noWrap={true}/>
            </div>
        );
    }
};

AlbumItemThumbnail.propTypes = {
    albumItemId: PropTypes.number.isRequired,
    albumItemDisplayOrder: PropTypes.number.isRequired,
    image: PropTypes.string,
    title: PropTypes.string,
    selected: PropTypes.bool,
    rotation: PropTypes.number,
    type: PropTypes.string,
    isEdited: PropTypes.bool,
    isOnDisc: PropTypes.bool,
    srcMediaUrl: PropTypes.string,
    duration: PropTypes.number

};



// WEBPACK FOOTER //
// ./src/album-view/components/album-item-thumbnail.jsx